import { DEFAULT_LANG } from '../constants';
import { urlJoin } from './utils';

export function getLocalizedUrlPath(path: string, lang: string): string {
  return lang === DEFAULT_LANG ? path : urlJoin(lang, path);
}
